import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  /* Global styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Base font for all languages */
  :root {
    font-family: 'Noto Sans', 'Noto Sans KR', 'Noto Sans JP', 'Noto Sans SC', sans-serif;
  }

  /* Language-specific font settings */
  :lang(ko) {
    font-family: 'Noto Sans KR', 'Noto Sans', sans-serif;
  }

  :lang(ja) {
    font-family: 'Noto Sans JP', 'Noto Sans', sans-serif;
  }

  :lang(zh) {
    font-family: 'Noto Sans SC', 'Noto Sans', sans-serif;
  }
`;

export default GlobalStyle;